export const translationsQuery = gql`
  query getTranslations($file: String!, $language: String!) {
    lang(file: $file, language: $language) {
      key
      value
    }
  }
`;
